// import {
//   Dialog,
//   DialogContent,
//   Box,
//   Typography,
//   TextField,
//   Button,
//   IconButton,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import GroupIcon from "@mui/icons-material/Group";

// export default function CreateGroupModal({ open, onClose, manager, onSuccess }) {
//   const mockLeads = [
//     { name: "Rahul Sharma", phone: "+91 9517025983" },
//     { name: "Sneha Gupta", phone: "+91 9741701320" },
//     { name: "Ravi Verma", phone: "+91 9060012838" },
//     { name: "Neha Jadhav", phone: "+91 9970593855" },
//     { name: "Deepak Patel", phone: "+91 9602418162" },
//     { name: "Meena Reddy", phone: "+91 9896806893" },
//   ];

//   const handleSubmit = () => {
//     onSuccess(manager?.id);
//     onClose();
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogContent sx={{ p: 3, borderRadius: 3 }}>

//         {/* Header */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//           <Box>
//             <Typography fontWeight={600} fontSize={18}>
//               Create Contact Group
//             </Typography>
//             <Typography fontSize={13} color="#6b7280">
//               Create a SmartFlo contact group for <b>{manager?.name}</b>
//             </Typography>
//           </Box>

//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         {/* Group Name */}
//         <Typography fontSize={13}>Group Name *</Typography>
//         <TextField
//           fullWidth
//           size="small"
//           sx={{ mt: 0.5, mb: 2 }}
//         />

//         {/* Description */}
//         <Typography fontSize={13}>Description</Typography>
//         <TextField
//           fullWidth
//           size="small"
//           multiline
//           rows={3}
//           sx={{ mt: 0.5, mb: 2 }}
//         />

//         {/* Leads Box */}
//         <Box
//           sx={{
//             border: "1px solid #e5e7eb",
//             borderRadius: 2,
//             p: 2,
//             bgcolor: "#f9fafb",
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//             <GroupIcon sx={{ fontSize: 18, color: "#2563eb" }} />
//             <Typography fontWeight={500} fontSize={14}>
//               Leads to Add
//             </Typography>
//           </Box>

//           <Typography fontSize={12} color="#6b7280" mb={1}>
//             {mockLeads.length} leads will be added to this contact group.
//           </Typography>

//           {/* Leads List */}
//           <Box
//             sx={{
//               maxHeight: 150,
//               overflowY: "auto",
//               pr: 1,
//             }}
//           >
//             {mockLeads.map((lead, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   fontSize: "13px",
//                   py: 0.5,
//                 }}
//               >
//                 <Typography>{lead.name}</Typography>
//                 <Typography color="#6b7280">{lead.phone}</Typography>
//               </Box>
//             ))}
//           </Box>
//         </Box>

//         {/* Footer */}
//         <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
//           <Button
//             variant="outlined"
//             onClick={onClose}
//             sx={{ textTransform: "none" }}
//           >
//             Cancel
//           </Button>

//           <Button
//             variant="contained"
//             onClick={handleSubmit}
//             sx={{
//               textTransform: "none",
//               bgcolor: "#2563eb",
//               px: 2.5,
//             }}
//           >
//             Create Contact Group
//           </Button>
//         </Box>

//       </DialogContent>
//     </Dialog>
//   );
// }

import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GroupIcon from "@mui/icons-material/Group";
import { useState, useEffect } from "react";
import { createGroupAndUpload } from "../../Services/SmartFloApis";

// submitApi (optional): override the API used on submit — same request/response
// contract as createGroupAndUpload. Used by the CP Sourcing team tab; the
// default keeps the original Sales Manager behaviour.
export default function CreateGroupModal({ open, onClose, manager, onSuccess, submitApi }) {

  const [form, setForm] = useState({
    name: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);

  // ✅ Auto-fill group name
  useEffect(() => {
    if (manager) {
      setForm({
        name: `${manager.name} Group`,
        description: `Leads for ${manager.name}`,
      });
    }
  }, [manager]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

    const payload = {
  name: form.name,
  description: form.description,
  userId: manager?.id,
  smartfloUserId: manager?.smartfloUserId, 
};

      console.log("🚀 GROUP PAYLOAD:", payload);

      const res = await (submitApi || createGroupAndUpload)(payload);

     console.log("🔥 FULL GROUP API RESPONSE:", res); // ✅ ADD THIS

console.log("🔥 GROUP ID FROM RESPONSE:", res?.smartfloGroupId); 
      if (res) {

        console.log("📤 Sending to parent:", manager?.id, res.smartfloGroupId);
        onSuccess(manager?.id, res.smartfloGroupId);
        onClose();
      } else {
        alert("Failed to create contact group");
      }

    } catch (error) {
      console.error("❌ GROUP ERROR:", error);
      alert("Error creating contact group");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 3, borderRadius: 3 }}>

        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Box>
            <Typography fontWeight={600} fontSize={18}>
              Create Contact Group
            </Typography>
            <Typography fontSize={13} color="#6b7280">
              Create a SmartFlo contact group for <b>{manager?.name}</b>
            </Typography>
          </Box>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Group Name */}
        <Typography fontSize={13}>Group Name *</Typography>
        <TextField
          fullWidth
          size="small"
          value={form.name}
          onChange={(e) => handleChange("name", e.target.value)}
          sx={{ mt: 0.5, mb: 2 }}
        />

        {/* Description */}
        <Typography fontSize={13}>Description *</Typography>
        <TextField
          fullWidth
          size="small"
          multiline
          rows={3}
          value={form.description}
          onChange={(e) => handleChange("description", e.target.value)}
          sx={{ mt: 0.5, mb: 2 }}
        />

        {/* Footer */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              textTransform: "none",
              bgcolor: "#2563eb",
              px: 2.5,
            }}
          >
            {loading ? "Creating..." : "Create Contact Group"}
          </Button>
        </Box>

      </DialogContent>
    </Dialog>
  );
}